import React from "react";
import I18n from "i18n-js";

import TrainingCourse from "./TrainingCourse";

const TrainingCourseSelector = ({ courses, selectedCourse }) => (
  <div className="training-course-selector">
    <div className="title">{I18n.t("training_courses.title")}</div>
    <div className="list">
      {courses?.map(c => (
        <TrainingCourse
          key={c.id}
          {...c}
          selected={selectedCourse.id === c.id}
        />
      ))}
    </div>
  </div>
);

export default TrainingCourseSelector;
